import React, { useState } from 'react'
import { SlTabGroup, SlTab, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import OrderEditor from './OrderEditor';
import LineitemEditor from './LineitemEditor';
import './NOCUpdates.scss';

function NOCUpdates() {
    const [tab, setTab] = useState('orders')
    return (
        <div className="noc-updates-page flex h-[calc(100vh-72px)] flex-col p-4 font-sans">
            <div className="shrink-0">
                <h4 className="mb-0 text-2xl font-semibold text-slate-800">NOC Updates</h4>
                <p className="mt-1 mb-0 text-sm text-slate-500">Update order and lineitem details.</p>
            </div>
            <SlTabGroup className="mt-3 flex min-h-0 flex-1 flex-col" onSlTabShow={(e) => setTab(e.detail.name)}>
                <SlTab slot="nav" panel="orders" active={tab === 'orders'}>Orders</SlTab>
                <SlTab slot="nav" panel="lineitems" active={tab === 'lineitems'}>LineItems</SlTab>

                <SlTabPanel name="orders">
                    {tab === 'orders' && <OrderEditor />}
                </SlTabPanel>
                <SlTabPanel name="lineitems">
                    {tab === 'lineitems' && <LineitemEditor />}
                </SlTabPanel>
            </SlTabGroup>
        </div>
    );
}

export default NOCUpdates;
